import { Component, ChangeDetectorRef, Input } from "@angular/core";
import { state, style, transition, animate, trigger } from "@angular/animations";

@Component({
    selector: 'hx-accordion-container, hxa-accordion-container',
    template: `    
    <li class="hx-accordion-container" [class.is-active]="expanded">
        <a class="hx-accordion-header" (click)="toggle()">
            <div class="header-title"><ng-content select="hx-accordion-header, hxa-accordion-header"></ng-content></div>
            <div class="header-icon">
                <i class="hx-icon icon-angle-down" *ngIf="!expanded"></i>
                <i class="hx-icon icon-angle-up" *ngIf="expanded"></i>
            </div>
        </a>
        <div class="hx-accordion-body" [@slideIn]="expanded" *ngIf="expanded">
            <div class="hx-accordion-body-wrapper">
                <ng-content select="hx-accordion-body, hxa-accordion-body"></ng-content>
            </div>
        </div>
    </li>
`,
    styles: [`.hx-accordion{list-style:none;background-color:#fff;border:1px solid rgba(0,0,0,.08);padding:0}.hx-accordion-container{margin-top:0}.hx-accordion-container:not(:last-child),:host:not(:last-child) .hx-accordion-container{box-shadow:inset 0 -1px 0 0 rgba(0,0,0,.08)}.hx-accordion-container:not(.is-active) .hx-accordion-header:hover{background-color:rgba(0,0,0,.02);text-decoration:none;color:#41b987}.hx-accordion-header{color:#2a2c2d;padding:1rem;display:flex;align-items:center;justify-content:space-between;transition:.3s}.hx-accordion-header:hover{color:#2a2c2d;text-decoration:none}.hx-accordion-header .header-icon{transition:.3s;display:flex}.hx-accordion-body{overflow-y:hidden;background-color:#fafafa;transition:.5s;box-shadow:inset 0 1px 0 0 rgba(0,0,0,.08)}.hx-accordion-body-wrapper{padding:1rem}`],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate('0.25s ease-out', style({ height: 0, opacity: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate('0.25s ease-out', style({ height: '*', opacity: 1 }))
            ])
        ])
    ]
})
export class AccordionContainerComponent {
    @Input() expanded = true;

    constructor(private _changeDetectionRef: ChangeDetectorRef) { }

    public toggle(): void {
        this.expanded = !this.expanded;
        this._changeDetectionRef.markForCheck();
    }
}
